const CLONE_DEEP_FLAG = 1
const CLONE_FLAT_FLAG = 2
const CLONE_SYMBOLS_FLAG = 4
const COMPARE_PARTIAL_FLAG = 1
const COMPARE_UNORDERED_FLAG = 2
const HASH_UNDEFINED = '__lodash_hash_undefined__'
const INFINITY = 1 / 0
const LARGE_ARRAY_SIZE = 200
const MAX_INTEGER = 1.7976931348623157e+308
const MAX_MEMOIZE_SIZE = 500
const MAX_SAFE_INTEGER = 9007199254740991
const NAN = 0 / 0

const CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.'
const FUNC_ERROR_TEXT = 'Expected a function'

const ARGS_TAG = '[object Arguments]'
const ARRAY_TAG = '[object Array]'
const ASYNC_TAG = '[object AsyncFunction]'
const BOOL_TAG = '[object Boolean]'
const DATE_TAG = '[object Date]'
const DOM_EXC_TAG = '[object DOMException]'
const ERROR_TAG  = '[object Error]'
const FUNC_TAG = '[object Function]'
const GEN_TAG = '[object GeneratorFunction]'
const MAP_TAG = '[object Map]'
const NUMBER_TAG = '[object Number]'
const NULL_TAG = '[object Null]'
const OBJECT_TAG = '[object Object]'
const PROMISE_TAG = '[object Promise]'
const PROXY_TAG = '[object Proxy]'
const REGEXP_TAG = '[object RegExp]'
const SET_TAG = '[object Set]'
const STRING_TAG = '[object String]'
const SYMBOL_TAG = '[object Symbol]'
const UNDEFINED_TAG = '[object Undefined]'
const WEAK_MAP_TAG = '[object WeakMap]'
const WEAK_SET_TAG = '[object WeakSet]'

const ARRAY_BUFFER_TAG = '[object ArrayBuffer]'
const DATA_VIEW_TAG = '[object DataView]'
const FLOAT_32_TAG = '[object Float32Array]'
const FLOAT_64_TAG = '[object Float64Array]'
const INT_8_TAG = '[object Int8Array]'
const INT_16_TAG = '[object Int16Array]'
const INT_32_TAG = '[object Int32Array]'
const UINT_8_TAG = '[object Uint8Array]'
const UINT_8_CLAMPED_TAG = '[object Uint8ClampedArray]'
const UINT_16_TAG = '[object Uint16Array]'
const UINT_32_TAG = '[object Uint32Array]'

export {
  CLONE_DEEP_FLAG,
  CLONE_FLAT_FLAG,
  CLONE_SYMBOLS_FLAG,
  COMPARE_PARTIAL_FLAG,
  COMPARE_UNORDERED_FLAG,
  HASH_UNDEFINED,
  INFINITY,
  LARGE_ARRAY_SIZE,
  MAX_INTEGER,
  MAX_MEMOIZE_SIZE,
  MAX_SAFE_INTEGER,
  NAN,

  CORE_ERROR_TEXT,
  FUNC_ERROR_TEXT,

  ARGS_TAG,
  ARRAY_TAG,
  ASYNC_TAG,
  BOOL_TAG,
  DATE_TAG,
  DOM_EXC_TAG,
  ERROR_TAG,
  FUNC_TAG,
  GEN_TAG,
  MAP_TAG,
  NUMBER_TAG,
  NULL_TAG,
  OBJECT_TAG,
  PROMISE_TAG,
  PROXY_TAG,
  REGEXP_TAG,
  SET_TAG,
  STRING_TAG,
  SYMBOL_TAG,
  UNDEFINED_TAG,
  WEAK_MAP_TAG,
  WEAK_SET_TAG,

  ARRAY_BUFFER_TAG,
  DATA_VIEW_TAG,
  FLOAT_32_TAG,
  FLOAT_64_TAG,
  INT_8_TAG,
  INT_16_TAG,
  INT_32_TAG,
  UINT_8_TAG,
  UINT_8_CLAMPED_TAG,
  UINT_16_TAG,
  UINT_32_TAG
}
